class Careers {
	
	static createComponents() {
		Vue.component('job-listing', {
			props: {
				job: Object
			}, 
			data: function() {
				return {
					
				};
			}, 
			computed: {
				jobURL: function() {
					return window.BASE_URL + `view-job/` + this.job.id;
				}
			}, 
			template: `<div class="job-listing" :id="'joblisting-' + this.job.id">
				<div class="job_name">
					<a :href="jobURL">{{ job.jobtitle }}</a>
				</div>
				<div class="job_summary">
					<div v-html="job.teaser"></div>
					<div class="job_readmore"><a :href="jobURL">read more</a></div>
				</div>
				
			</div>`
		});
	}
	
}